import { Map } from 'immutable';
import { createSelector } from 'reselect';
function restrict(state, scope) {
  return state.getIn([scope, 'config']) || Map();
}
export var getConfig = createSelector(restrict, function (config) {
  return config.toJS();
});